import React from 'react';
import Link from 'next/link';
import { Button } from '@kiiwi/ui';
import { useTranslation } from '@/src/i18n';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';

interface Props {
  href: Record<string, any>;
  onClick: () => void;
}
const SeeMoreButton: React.FC<Props> = ({ href, onClick }) => {
  const { t } = useTranslation();
  return (
    <Link href={href} passHref legacyBehavior>
      <Button variant="ghost" size="md" onClick={onClick}>
        {t('show_more')}
        <FontAwesomeIcon name="arrow-right-long:regular" className="ml-2" />
      </Button>
    </Link>
  );
};

export default React.memo(SeeMoreButton);
